import { useEffect, useContext } from "react";
import Header from "./Header";
import useState from "react-usestateref";
import authservices from "../services/authservices";
import { Link } from "react-router-dom";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const Strategy = () => {
  const [userAuth, setAuth, userAuthref] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    getSitedata();
  }, []);
  const [siteDatacomes, setSiteData] = useState("");

  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <main className="wyscale_landing_main">
        <Header />
      </main>

      <section className="dashboard_content_section">
        <div className="container">
          <div className="smart_dashboard_content" id="terms-condition">
            <h2>{t("Strategy")}</h2>
            <div className="row">
              <div className="col-lg-12">
                <div className="dash_board_profile_content cnt_bx">
                  <div className="contentpage">
                    <h2>{t("DCAstratagy")}</h2>
                    <p>{t("DCAstratagycont1")}</p>
                    <p>{t("DCAstratagycont2")}</p>
                    <h3>{t("DCAstratagyhead1")}</h3>
                    <ul>
     {t("DCAstratagyhead1.1")&&<li>{t("DCAstratagyhead1.1")}</li>}
     {t("DCAstratagyhead1.2")&&<li>{t("DCAstratagyhead1.2")}</li>}
     {t("DCAstratagyhead1.3")&&<li>{t("DCAstratagyhead1.3")}</li>}
     {t("DCAstratagyhead1.4")&&<li>{t("DCAstratagyhead1.4")}</li>}
                    </ul>
                    <p>{t("DCAstratagyhead1cont1")}</p>
                    <h3>{t("DCAstratagyhead2")}</h3>
                    <p>{t("DCAstratagyhead2cont1")}</p>
                     <ul>
     {t("DCAstratagyhead2.1")&&<li>{t("DCAstratagyhead2.1")}</li>}
    {t("DCAstratagyhead2.1.1") &&  <p>{t("DCAstratagyhead2.1.1")}</p>}
     {t("DCAstratagyhead2.2")&&<li>{t("DCAstratagyhead2.2")}</li>}
     {t("DCAstratagyhead2.2.1")&&<p>{t("DCAstratagyhead2.2.1")}</p>}
     {t("DCAstratagyhead2.3")&&<li>{t("DCAstratagyhead2.3")}</li>}
     {t("DCAstratagyhead2.3.1")&&<p>{t("DCAstratagyhead2.3.1")}</p>}
     {t("DCAstratagyhead2.4")&&<li>{t("DCAstratagyhead2.4")}</li>}
     {t("DCAstratagyhead2.4.1")&&<p>{t("DCAstratagyhead2.4.1")}</p>}
                    </ul>
                    <h3>{t("DCAstratagyhead3")}</h3>
                    {t("DCAstratagyhead3") &&  <ul>
     {t("DCAstratagyhead3.1")&&<li>{t("DCAstratagyhead3.1")}</li>}
     {t("DCAstratagyhead3.2")&&<li>{t("DCAstratagyhead3.2")}</li>}
     {t("DCAstratagyhead3.3")&&<li>{t("DCAstratagyhead3.3")}</li>}
                    </ul>}

                    <h2>{t("intrastratagy")}</h2>
                    <p>{t("intrastratagycontent1")}</p>
                    <p>{t("intrastratagycontent2")}</p>
                    <h3>{t("intrastratagyhead1")}</h3>
                    <ul>
                      {t("intrastratagyhead1.1")&&<li>{t("intrastratagyhead1.1")}</li>}
                      {t("intrastratagyhead1.2")&&<li>{t("intrastratagyhead1.2")}</li>}
                      {t("intrastratagyhead1.3")&&<li>{t("intrastratagyhead1.3")}</li>}
                      {t("intrastratagyhead1.4")&&<li>{t("intrastratagyhead1.4")}</li>}
                    </ul>
                    <p>{t("intrastratagyhead1content")}</p>
                    <h3>{t("intrastratagyhead2")}</h3>
                      <ul>
                      {t("intrastratagyhead2.1")&&<li>{t("intrastratagyhead2.1")}</li>}
                      {t("intrastratagyhead2.2")&&<li>{t("intrastratagyhead2.2")}</li>}
                      {t("intrastratagyhead2.3")&&<li>{t("intrastratagyhead2.3")}</li>}
                      {t("intrastratagyhead2.4")&&<li>{t("intrastratagyhead2.4")}</li>}
                    </ul>
                    <p>{t("intrastratagyhead2content")}</p>

                      <h2>{t("triangularstratagy")}</h2>
                    <p>{t("triangularstratagycont1")}</p>
                    <p>{t("triangularstratagycont2")}</p>
                    <p>{t("triangularstratagycont3")}</p>
                    <ul>
                      {t("triangularstratagycont3.1")&&<li>{t("triangularstratagycont3.1")}</li>}
                      {t("triangularstratagycont3.2")&&<li>{t("triangularstratagycont3.2")}</li>}
                      {t("triangularstratagycont3.3")&&<li>{t("triangularstratagycont3.3")}</li>}
                      </ul>
                      <p>{t("triangularstratagycont4")}</p>
                    <h3>{t("triangularstratagyhead1")}</h3>
                      {t("triangularstratagyhead1con1")&&<p>{t("triangularstratagyhead1con1")}</p>}
                      {t("triangularstratagyhead1con2")&&<p>{t("triangularstratagyhead1con2")}</p>}
                      {t("triangularstratagyhead1con3")&&<p>{t("triangularstratagyhead1con3")}</p>}
                      {t("triangularstratagyhead1con4")&&<p>{t("triangularstratagyhead1con4")}</p>}
                    <p>{t("triangularstratagyhead1con5")}</p>
                    <p>{t("triangularstratagyhead1con6")}</p>
                      <ul>
                      {t("triangularstratagyhead1con6.1")&&<li>{t("triangularstratagyhead1con6.1")}</li>}
                      {t("triangularstratagyhead1con6.2")&&<li>{t("triangularstratagyhead1con6.2")}</li>}
                      {t("triangularstratagyhead1con6.3")&&<li>{t("triangularstratagyhead1con6.3")}</li>}
                    </ul>
                    {/* <p> {t("triangularstratagyhead1con4")}</p> */}
                    <p>{t("triangularstratagyhead1con7")}</p>

                    <h3>{t("triangularstratagyhead2")}</h3>
                      <ul>
                      {t("triangularstratagyhead2.1")&&<li>{t("triangularstratagyhead2.1")}</li>}
                      {t("triangularstratagyhead2.2")&&<li>{t("triangularstratagyhead2.2")}</li>}
                      {t("triangularstratagyhead2.3")&&<li>{t("triangularstratagyhead2.3")}</li>}
                      {t("triangularstratagyhead2.4")&&<li>{t("triangularstratagyhead2.4")}</li>}
                    </ul>
                    
                    <h2>{t("arbitragestratagy")}</h2>
                     <p>{t("arbitragestratagycont1")}</p>
                    <p>{t("arbitragestratagycont2")}</p>
                    <p>{t("arbitragestratagycont3")}</p>
                      {/* <h2>{t("arbitragestratagyhead1")}</h2>
                    <p>{t("arbitragestratagycont1")}</p>
                    <p>{t("arbitragestratagycont2")}</p>
                    <p>{t("arbitragestratagycont3")}</p> */}

                    <h3>{t("arbitragestratagyhead1")}</h3>
                   <p>{t("arbitragestratagyhead1cont1")}</p>
                    <ul>
                      {t("arbitragestratagyhead1cont1.1")&&<li>{t("arbitragestratagyhead1cont1.1")}</li>}
                      {t("arbitragestratagyhead1cont1.2")&&<li>{t("arbitragestratagyhead1cont1.2")}</li>}
                    </ul>
                    <p>{t("arbitragestratagyhead1cont2")}</p>
                    <p>{t("arbitragestratagyhead1cont2.1")}</p>
                    <p>{t("arbitragestratagyhead1cont2.2")}</p>
                    <p>{t("arbitragestratagyhead1cont2.3")}</p>
                    <ul>
                      {t("arbitragestratagyhead1cont2.3.1") && <li>{t("arbitragestratagyhead1cont2.3.1")}</li>}
                      {t("arbitragestratagyhead1cont2.3.2") && <li>{t("arbitragestratagyhead1cont2.3.2")}</li>}
                    </ul>
                    <p>{t("arbitragestratagyhead1cont2.4")}</p>

                    <h3>{t("arbitragestratagyhead2")}</h3>
                      <ul>
                      {t("arbitragestratagyhead3cont1.1")&&<li>{t("arbitragestratagyhead3cont1.1")}</li>}
                      {t("arbitragestratagyhead3cont1.2")&&<li>{t("arbitragestratagyhead3cont1.2")}</li>}
                      {t("arbitragestratagyhead3cont1.3")&&<li>{t("arbitragestratagyhead3cont1.3")}</li>}
                    </ul>
                     <h3>{t("arbitragestratagyhead3")}</h3>
                      <ul>
                      {t("arbitragestratagyhead4cont1.1")&&<li>{t("arbitragestratagyhead4cont1.1")}</li>}
                      {t("arbitragestratagyhead4cont1.2")&&<li>{t("arbitragestratagyhead4cont1.2")}</li>}
                      {t("arbitragestratagyhead4cont1.3")&&<li>{t("arbitragestratagyhead4cont1.3")}</li>}
                      {t("arbitragestratagyhead4cont1.4")&&<li>{t("arbitragestratagyhead4cont1.4")}</li>}
                    </ul>
                    <p>{t("arbitragestratagyhead4cont")}</p>
                    
                    <h2>{t("momentumstratagy")}</h2>
                    <p>{t("momentumstratagycont1")}</p>
                    <p>{t("momentumstratagycont2")}</p>
                    <h3>{t("momentumstratagyhead1")}</h3>
                    <p>{t("momentumstratagyhead1.1")}</p>
                    <p>{t("momentumstratagyhead1.2")}</p>
                    <ul>
                      {t("momentumstratagyhead1.2.1") && <li>{t("momentumstratagyhead1.2.1")}</li>}
                      {t("momentumstratagyhead1.2.2") && <li>{t("momentumstratagyhead1.2.2")}</li>}
                      {t("momentumstratagyhead1.2.3") && <li>{t("momentumstratagyhead1.2.3")}</li>}
                    </ul>
                    <p>{t("momentumstratagyhead1.3")}</p>
                    <p>{t("momentumstratagyhead1.4")}</p>
                     <ul>
                      {t("momentumstratagyhead1.4.1") && <li>{t("momentumstratagyhead1.4.1")}</li>}
                      {t("momentumstratagyhead1.4.1") && <li>{t("momentumstratagyhead1.4.2")}</li>}
                    </ul>
                    <p>{t("momentumstratagyhead1.5")}</p>
                    <p>{t("momentumstratagyhead1.7")}</p>
                     <p>{t("momentumstratagyhead1.6")}</p>
                    <h3>{t("momentumstratagyhead2")}</h3>
  <ul>
                      {t("momentumstratagyhead2.1") && <li>{t("momentumstratagyhead2.1")}</li>}
                      {t("momentumstratagyhead2.2") && <li>{t("momentumstratagyhead2.2")}</li>}
                      {t("momentumstratagyhead2.3") && <li>{t("momentumstratagyhead2.3")}</li>}
                      {t("momentumstratagyhead2.4") && <li>{t("momentumstratagyhead2.4")}</li>}
                    </ul>
                    <p>{t("momentumstratagyhead2cont1")}</p>

                    <p>{t("momentumstratagyhead2cont2")}</p>

                  </div>
                  {/* <div className="contentpage">
                    <h3 className="text-center fz_22">{t("DCAStrategy1")} </h3>
                    <p>{t("DollarCostAveragingStrategy")}</p>
                    <p>{t("DCABot")}</p>
                    <h3>{t("WhatDoesTheDCADo")}</h3>

                    <p>{t("DCABuys")}</p>
                    <p>{t("MarketMoves")}</p>

                    <h3>{t("KeyBenefitsOfTheDCA")}</h3>

                    <ul className="num_lists_guide">
                      <li>
                        <h3 className="mt-2">
                          {t("TheBotConstantlyWatchesTheMarket")}
                        </h3>
                        <ul>
                          <li>{t("BotEnables")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("AssetAccumulation")}</h3>
                        <ul>
                          <li>{t("DCABotIsAnExcellent")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("HigherAverageProfits")}</h3>
                        <ul>
                          <li>{t("DCABotToExecuteGradual")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">
                          {t("StableProfitsWithMinimalRisks")}
                        </h3>
                        <ul>
                          <li>{t("EvenInMarkets")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("AutomatedTrading1")}</h3>
                        <ul>
                          <li>{t("DCABotSimplifies")}</li>
                        </ul>
                      </li>
                    </ul>

                    <h3>{t("HowDoesTheDCAWorkInCrypto")}</h3>
                    <p>{t("DCAInCrypto")}</p>

                    <ul className="num_lists_guide">
                      <li> {t("InitialOrder")}</li>
                      <li>{t("AdaptingToMarketMovements")}</li>
                      <li>{t("AutomaticAdjustments")}</li>
                    </ul>

                    <p>{t("WithTheDCA")}</p>

                    <h3 className="text-center mt-5 fz_22">
                      {t("INTRAStrategy")}
                    </h3>
                    <p>{t("IntraStrategy")} </p>

                    <h3>{t("HowIntraStrategyWorksInACryptoTradingBot")}</h3>

                    <h3>1. {t("DefiningTheTimeFrame")}</h3>
                    <ul className="num_lists_guide">
                      <li>{t("IntraStrategyIsDesigned")}</li>
                      <li>{t("botAlgorithm")}</li>
                    </ul>

                    <h3>2. {t("UsingTechnicalIndicators")}</h3>
                    <p>{t("BotUsesVarietyOfTechnical")}</p>
                    <ul className="num_lists_guide">
                      <li>{t("MovingAverages")}</li>
                      <li>{t("RSI")}</li>
                      <li>{t("BollingerBands")}</li>
                      <li>{t("MACD")}</li>
                    </ul>

                    <h3>3. {t("AutomaticBuy")}</h3>
                    <ul className="num_lists_guide">
                      <li>{t("BotIdentifiesFavorable")}</li>
                      <li>{t("BotMayAlsoSetStopLoss")}</li>
                    </ul>

                    <h3>4. {t("RiskManagement")}</h3>
                    <ul className="num_lists_guide">
                      <li>{t("StopLossOrders")}</li>
                      <li>{t("TakeProfitOrders")}</li>
                    </ul>

                    <h3>5. {t("AdaptingToMarketConditions")}</h3>
                    <ul className="num_lists_guide">
                      <li>{t("BotCanAdjust")}</li>
                      <li>{t("Conversely")}</li>
                    </ul>

                    <h3 className="text-center mt-5 fz_22">
                      {t("TRIANGULARStrategy")}
                    </h3>
                    <p>{t("TriangularStrategy")}</p>

                    <h3>{t("HowItWorks")}</h3>
                    <ul className="num_lists_guide">
                      <li>
                        <p className="mt-2">
                          {t("IdentifyThreeCurrencyPairs")}
                        </p>
                        <ul>
                          <li>{t("Pair1")}</li>
                          <li>{t("Pair2")} </li>
                          <li>{t("Pair3")}</li>
                        </ul>
                      </li>
                      <li>
                        <p className="mt-2">
                          {" "}
                          {t("LookForPriceDiscrepancies")}
                        </p>
                      </li>
                      <li>
                        <p className="mt-2">{t("ExecuteThreeTrades")}</p>
                        <ul>
                          <li>{t("Trade1")}</li>
                          <li>{t("Trade2")}</li>
                          <li>{t("Trade3")}</li>
                        </ul>
                      </li>
                      <li>
                        <p className="mt-2">{t("CheckForProfit")}</p>
                      </li>
                    </ul>

                    <h3>{t("Example")}</h3>
                    <ul className="num_lists_guide">
                      <li>
                        <p className="mt-2">{t("StartingWith1000usdt")}</p>
                        <ul>
                          <li>{t("BTC/usdt")}</li>
                          <li>{t("ETH/usdt")}</li>
                          <li> {t("BTC/ETH")}</li>
                        </ul>
                      </li>

                      <li>
                        <p className="mt-2">
                          {" "}
                          {t("TheBotPerformsTheFollowingSteps")}
                        </p>
                        <ul>
                          <li>{t("Step1")} </li>
                          <li>{t("Step2")}</li>
                          <li> {t("Step3")}</li>
                        </ul>
                      </li>

                      <li>
                        <p className="mt-2">{t("AfterCompletingTheTrades")}</p>
                      </li>
                    </ul>

                    <h3>{t("KeyComponentsForATriangularArbitrageBot")}</h3>
                    <ul className="num_lists_guide">
                      <li>{t("MarketDataRetrieval")}</li>
                      <li>{t("IdentifyingArbitrageOpportunities")}</li>
                      <li>{t("FastExecutionOfTrades")}</li>
                      <li>{t("TransactionCosts")}</li>
                      <li>{t("ErrorHandling")}</li>
                    </ul>

                    <h3 className="text-center mt-5 fz_22">
                      {t("ARBITRAGEStrategy")}
                    </h3>
                    <p>{t("ArbitrageStrategy")}</p>
                    <h3>{t("HowArbitrageWorks")}</h3>
                    <p>{t("BasicIdeaBehind")}</p>
                    <h3>{t("ExampleScenario")}</h3>
                    <ul className="num_lists_guide">
                      <li>{t("ExchangeA")}</li>
                      <li>{t("ExchangeB")}</li>
                      <li> {t("BotIdentifies")} </li>
                      <li>{t("BotThenSells")}</li>
                    </ul>

                    <h3>{t("StepsInvolvedInArbitrage")}</h3>
                    <ul className="num_lists_guide">
                      <li>
                        <h3 className="mt-2">
                          {t("IdentifyArbitrageOpportunity")}
                        </h3>
                        <ul>
                          <li>{t("BotContinuouslyMonitors")}</li>
                          <li>{t("BotComparesPrices")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("ExecuteBuyOnExchangeA")}</h3>
                        <ul>
                          <li>{t("OnceThePrice")}</li>
                          <li>{t("BotBuysACertainAmount")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("TransferTheCryptoAsset")}</h3>
                        <ul>
                          <li>{t("Arbitrage")}</li>
                          <li>{t("SpeedOfTheTransfer")}</li>
                          <li>{t("BotChecksBlockchain")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("ExecuteSellOnExchangeB")}</h3>
                        <ul>
                          <li>{t("AfterTheBTC")}</li>
                          <li>{t("TransferFunds")}</li>
                        </ul>
                      </li>
                    </ul>

                    <h3>{t("KeyComponentsOfAArbitrageBot")}</h3>
                    <ul className="num_lists_guide">
                      <li>
                        <h3 className="mt-2">{t("RealTimePriceMonitoring")}</h3>
                        <ul>
                          <li>{t("BotUsesAPIs")}</li>
                          <li>{t("CryptocurrencyPairs")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">
                          {t("ProfitabilityCalculation")}
                        </h3>
                        <ul>
                          <li>{t("BotCalculatesPotential")}</li>
                          <li>
                            {t("ItFactorsIn")}
                            <ul>
                              <li>{t("TradingFeesOnBothExchanges")}</li>
                              <li>
                                {t(
                                  "TransferFeesForMovingFundsBetweenExchanges"
                                )}
                              </li>
                              <li>{t("BlockchainNetworkFees")}</li>
                              <li>{t("Slippage—the")}</li>
                              <li>{t("TransferSpeed")}</li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("FastTradeExecution")}</h3>
                        <ul>
                          <li>{t("ArbitrageOpportunityIsFound")}</li>
                          <li>{t("IfNecessary")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("LiquidityCheck")}</h3>
                        <ul>
                          <li>{t("Bot")}</li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="mt-2">{t("RiskManagement")}</h3>
                        <ul>
                          <li>{t("TheBotMustHandleRisksLike")}</li>
                          <ul>
                            <li>{t("PriceMovement")}</li>
                            <li>{t("NetworkCongestion")}</li>
                            <li>{t("Fees")}</li>
                          </ul>
                        </ul>
                      </li>
                    </ul>

                    <h3 className="text-center mt-5 fz_22">
                      {t("MomentumTradingStrategy")}
                    </h3>

                    <h3 className="fz_22">{t("StrategyObjective")}</h3>
                    <p>{t("CaptureProfits")}</p>

                    <h3>1. {t("TokenSelection")}</h3>
                    <h3>{t("Input")}</h3>
                    <ul>
                      <li>{t("PriceData")}</li>
                      <li>{t("Filtering")}</li>
                      <li>{t("TokenVolumeAndMarketCapThresholds")}</li>
                    </ul>
                    <h3>{t("Conditions")}</h3>
                    <ul>
                      <li>{t("24hPriceIncrease")}</li>
                      <li>{t("Above50")}</li>
                      <li>{t("4hAverage")}</li>
                      <li>{t("TokenIsAvailableOnSelectedExchange")}</li>
                    </ul>

                    <h3>2. {t("EntryLogic")}</h3>
                    <ul>
                      <li>{`RSI (1h) > 50 and rising`}</li>
                      <li>{`RSI (15min) also > 50 (multi-timeframe alignment)`}</li>
                      <li>{`Optional: 5EMA > 20EMA on 1h chart (bullish crossover)`}</li>
                      <li>{`Volume increasing over last 3 candles`}</li>
                    </ul>
                    <h3>{t("Execution")}</h3>
                    <ul>
                      <li>{t("Market")}</li>
                      <li>{t("PositionSize")}</li>
                    </ul>

                    <h3>3. {t("TakeProfitLogic")}</h3>
                    <h3>{t("Modes")}</h3>
                    <ul>
                      <li>{t("FixedTP")}</li>
                      <li>{t("DynamicTP")}</li>
                      <ul>
                        <li>{t("Calculate")}</li>
                        <li>{t("SetTP")}</li>
                      </ul>
                    </ul>
                    <h3>{t("Optional")}</h3>
                    <ul>
                      <li>{t("PartialTP")}</li>
                      <li>{t("TrailingTP")}</li>
                    </ul>

                    <h3>4. {t("RiskManagement")}</h3>
                    <h3>{t("StopLoss")}</h3>
                    <ul>
                      <li>{t("StaticSL")}</li>
                      <li>{t("DynamicSL")}</li>
                      <ul>
                        <li>{t("SetAtRecentSwingLow")}</li>
                        <li>{t("CrossingDownward")}</li>
                      </ul>
                    </ul>
                    <h3>{t("BreakEvenLogic")}</h3>
                    <ul>
                      <li>{t("PriceIncreases")}</li>
                      <li>{t("Prevents")}</li>
                    </ul>

                    <h3>5. {t("ExitLogicAndReallocation")}</h3>
                    <ul>
                      <li>{t("SellEntirePositionWhen")}</li>

                      <ul>
                        <li>{t("TPTargetHit")}</li>
                        <li>{t("StopLossTriggered")}</li>
                        <li>{t("TrailingTPHits")}</li>
                      </ul>
                      <li>{t("Chasing")} </li>
                    </ul>

                    <h3>{t("DashboardIntegration")}</h3>
                    <ul>
                      <li>{t("ShowActiveMomentumTrades")}</li>
                      <li>{t("Visuals")}</li>
                      <li>{t("LogBreakoutConfirmationTriggers")}</li>
                    </ul>

                    <h3> {t("ConfigurableParameters")} </h3>

                    <div className="table-responsive home_recent_table table_st_border">
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="text_left">{t("Parameter")}</th>
                            <th>{t("Description")}</th>
                            <th>{t("DefaultValue")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{t("24hGainFilter")}</td>
                            <td>{t("TopGainerThreshold")}</td>
                            <td>{t("5–15%")}</td>
                          </tr>
                          <tr>
                            <td>{t("24hGainFilter")}</td>
                            <td>{t("TopGainerThreshold")}</td>
                            <td>{t("5–15%")}</td>
                          </tr>
                          <tr>
                            <td>{t("RSITimeframe")}</td>
                            <td>{t("TimeframeForRSIConfirmation")}</td>
                            <td>{t("15min")}</td>
                          </tr>
                          <tr>
                            <td>{t("TakeProfit")}</td>
                            <td>{t("FixedDynamic")}</td>
                            <td>{t("7%")}</td>
                          </tr>
                          <tr>
                            <td>{t("StopLoss%")}</td>
                            <td>{t("StaticDynamic")}</td>
                            <td>{t("MA20")}</td>
                          </tr>
                          <tr>
                            <td>{t("BreakEvenActivation")}</td>
                            <td>{t("MoveSLToEntryAfterGainThreshold")}</td>
                            <td>{t("+4%")}</td>
                          </tr>
                          <tr>
                            <td>{t("ReEntryCooldown")}</td>
                            <td>{t("PreventReTradeOfSameToken")}</td>
                            <td>{t("12h")}</td>
                          </tr>
                          <tr>
                            <td>{t("Positionsize")}</td>
                            <td>{t("usdtPerTrade")}</td>
                            <td>{t("5%")}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SubFooter />
    </>
  );
};

export default Strategy;
